import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface InventoryValidationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  inventoryData: any[];
  onValidate: () => void;
}

export const InventoryValidationDialog = ({
  open,
  onOpenChange,
  inventoryData,
  onValidate,
}: InventoryValidationDialogProps) => {
  const hasDiscrepancies = inventoryData.some(item => item.difference !== 0);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Validation de l'inventaire</DialogTitle>
          <DialogDescription>
            Vérifiez les résultats du comptage avant de valider
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[60vh] overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Produit</TableHead>
                <TableHead>Quantité système</TableHead>
                <TableHead>Quantité comptée</TableHead>
                <TableHead>Différence</TableHead>
                <TableHead>Notes</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {inventoryData.map((item) => (
                <TableRow key={item.itemId}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.systemQuantity}</TableCell>
                  <TableCell>{item.countedQuantity}</TableCell>
                  <TableCell className={item.difference !== 0 ? 'text-red-600' : 'text-green-600'}>
                    {item.difference}
                  </TableCell>
                  <TableCell>{item.notes || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {hasDiscrepancies && (
          <p className="text-yellow-600 text-sm mt-4">
            ⚠️ Des écarts ont été détectés. Veuillez vérifier les quantités avant de valider.
          </p>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Retour
          </Button>
          <Button onClick={onValidate}>
            Valider l'inventaire
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};